import type { Project } from '@finsim/model';
import type { TFunction } from 'i18next';
import { newId } from '../../shared/lib/id';
import { buildProject, type ProjectTemplate } from './templates';

/** Builds a template project with names in the current language and a fresh random seed. */
export function buildLocalizedProject(
  template: ProjectTemplate,
  name: string,
  t: TFunction,
): Project {
  return buildProject(
    template,
    {
      projectName: name,
      category: (k) => t(`categories.${k}`),
      item: (k) => t(`templates.${k}`),
      variant: (k) => t(`createProject.variants.${k}`),
      extra: (k) => t(`createProject.items.${k}`),
      keyDate: (k) => t(`createProject.keyDates.${k}`),
    },
    {
      id: newId,
      now: new Date(),
      currency: 'EUR',
      seed: crypto.getRandomValues(new Uint32Array(1))[0] ?? 1,
    },
  );
}
